import { DistrictExistsGuard } from './district-exists.guard';
import { DistrictSearchResultsGuard } from './district-searchresults.guard';

export const guards: any[] = [DistrictExistsGuard, DistrictSearchResultsGuard];

export * from './district-exists.guard';
export * from './district-searchresults.guard';
